<template>
  <section id="checkout" class="checkout-section">
    <div class="container">
      <div class="checkout-content">
        <div class="row">
          <div class="col-md-9">

            <div class="order-payment">
              <div class="section-title-2  headline text-left">
                <h2>证书 <span>查询</span></h2>
              </div>
              <div class="payment-method">

                <el-form :model="queryModel" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="check-out-form">
                  <el-form-item label="证书编号:">
                    <div class="payment-info">
                      <input type="text" class="form-control" placeholder="" v-model="queryModel.CertCode">
                    </div>
                  </el-form-item>
                  <el-form-item label="姓名:">
                    <div class="payment-info">
                      <input type="text" class="form-control" placeholder="" v-model="queryModel.EmployeeName">
                    </div>
                  </el-form-item>
                  <el-form-item label="身份证号:" prop="EmployeeIdNumber">
                    <div class="payment-info">
                      <input type="text" class="form-control" placeholder="" v-model="queryModel.EmployeeIdNumber">
                    </div>
                  </el-form-item>
                </el-form>

              </div>

              <div class="">
                <div style='    padding-bottom: 20px; margin-top: -20px;'><span style="font-size:14px;color:#f56c6c;">{{Message}}</span></div>
                <el-button class="k-btn normal" @click="onSubmit">查 询</el-button>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <component :is="newsView" ref="newsView"></component>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Vue } from '../base/base.js';
export default {
  data() {
    return {
      queryModel: {
        CertCode: '',
        EmployeeName: '',
        EmployeeIdNumber: ''
      },
      Message: '',
      rules: {
        EmployeeIdNumber: [
          { required: true, message: '请填写身份证号', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },
  methods: {
    onSubmit() {
      this.$alert('未查询到相关证书！', '证书查询', {
        confirmButtonText: '确定',
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      });
      // this.$store.dispatch('getSearchCerts', this.queryModel);
      // this.$refs.ruleForm.validate((valid) => {
      //   if (valid) {
      //     this.$store.dispatch('getSearchCerts', this.queryModel).then((response) => {
      //       if (response.MsgCode === 0) {
      //         this.$router.push({ name: 'diplomainfo' })
      //       } else {
      //         this.Message = response.Message;
      //       }
      //     });
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-info {
  width: 700px;
  input {
    width: 100%;
  }
}
</style>

<style scoped>
.el-form-item >>> .el-form-item__label {
  line-height: 50px;
}

.el-form-item >>> .el-form-item__error {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/diploma_search.vue